export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00976.cd15ac66.png";